module.exports = __webpack_public_path__ + "img/25-Women’s Health.a03adbe0.png";